import { Component, EventEmitter, Input, OnInit, Output, OnChanges, SimpleChanges } from '@angular/core';
import { CommonModule } from '@angular/common';
import { FormBuilder, FormGroup, ReactiveFormsModule, Validators } from '@angular/forms';
import { AddPopupComponent } from '../add-popup/add-popup.component';
import { faXmark, faTrashCan } from '@fortawesome/free-solid-svg-icons';
import { FontAwesomeModule } from '@fortawesome/angular-fontawesome';
import ClassicEditor from '@ckeditor/ckeditor5-build-classic';
import { CKEditorModule } from '@ckeditor/ckeditor5-angular';
@Component({
  selector: 'app-policies-table',
  standalone: true,
  imports: [CommonModule, ReactiveFormsModule, AddPopupComponent, FontAwesomeModule, CKEditorModule],
  templateUrl: './policies-table.component.html',
  styleUrl: './policies-table.component.css'
})
export class PoliciesTableComponent implements OnInit, OnChanges {
  public Editor = ClassicEditor;
  faXmark = faXmark;
  faTrashCan = faTrashCan;
  showModal = false;
  isEditMode = false;
  viewHistory = false;
  showSkeleton = true;
  showDeleteModal = false;
  expandedIndices: number[] = [1];
  @Input() policies: any[] = [];
  @Input() loading = false;
  @Output() addPolicy = new EventEmitter<any>();
  @Output() editPolicy = new EventEmitter<{ id: any, data: any }>();
  @Output() deletePolicy = new EventEmitter<any>();
  policyToDeleteId: number | null = null;
  selectedPolicyId: number | null = null;

  policyForm: FormGroup;

  constructor(private fb: FormBuilder) {
    this.policyForm = this.fb.group({
      policy_title: ['', Validators.required],
      policy_description: ['', Validators.required]
    });
  }

  ngOnChanges() {
    if (this.loading) {
      this.showTableLoader();
    }
  }
  ngOnInit(): void {
    this.showTableLoader();
  }
  skeletonRows: any[] = [];
  skeletonCols: any[] = [];

  showTableLoader(duration = 800) {
    this.showSkeleton = true;

    const rowCount = this.policies?.length || 5;
    const columnCount = 3; // 👈 match your table columns

    this.skeletonRows = Array(rowCount).fill(0);
    this.skeletonCols = Array(columnCount).fill(0);

    setTimeout(() => {
      this.showSkeleton = false;
    }, duration);
  }
  toggleModal() {
    this.showModal = !this.showModal;
    if (!this.showModal) {
      this.isEditMode = false;
      this.selectedPolicyId = null;
      this.policyForm.reset();
    }
  }

  openEditModal(item: any) {
    this.isEditMode = true;
    this.showModal = true;
    this.selectedPolicyId = item.id;
    this.policyForm.patchValue({
      policy_title: item.policy_title,
      policy_description: item.policy_description || ''
    });
  }

  openHistory() {
    this.viewHistory = true;
  }

  toggleCollapse(index: number) {
    if (this.expandedIndices.includes(index)) {
      this.expandedIndices = this.expandedIndices.filter(i => i !== index);
    } else {
      this.expandedIndices.push(index);
    }
  }

  onSave() {
    if (this.policyForm.invalid) return;

    const payload = this.policyForm.value;

    if (this.isEditMode && this.selectedPolicyId !== null) {
      this.editPolicy.emit({ id: this.selectedPolicyId, data: payload });
    } else {
      this.addPolicy.emit(payload);
    }
    this.toggleModal();
  }

  openDeleteModal(id: number) {
    this.policyToDeleteId = id;
    this.showDeleteModal = true;
  }

  confirmDelete() {
    if (this.policyToDeleteId !== null) {
      this.deletePolicy.emit(this.policyToDeleteId);
    }
    this.showDeleteModal = false;
    this.policyToDeleteId = null;
  }

  closeDeleteModal() {
    this.showDeleteModal = false;
    this.policyToDeleteId = null;
  }
}
